import { messageCardUtil } from './MatchBody';

interface EducationProviderMessageCardProps extends React.HTMLAttributes<HTMLDivElement> {
  content: any;
}

const EducationProviderMessageCard = ({ content }: EducationProviderMessageCardProps) => {
  const options: any = {};

  options.entityColor = 'deep-400';
  options.entityName = 'education_provider';

  return messageCardUtil({ content, options });
};

export default EducationProviderMessageCard;
